import React from 'react';
import { IconButton } from '@miro-site/core';
import styled, { css } from 'styled-components';
import theme from './theme';
import { AppStore, GooglePlay, LogoSquare, NewLogoSquare } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var icons = {
  appStore: /*#__PURE__*/_jsx(AppStore, {
    backgroundColor: "var(--wcds-footer-app-store-logo-background-color)",
    width: [123, 144, 134, 134, 144],
    height: [42, 48, 45, 45, 48]
  }),
  googlePlay: /*#__PURE__*/_jsx(GooglePlay, {
    backgroundColor: "var(--wcds-footer-app-store-logo-background-color)",
    width: [139, 162, 152, 152, 162],
    height: [42, 48, 45, 45, 48]
  }),
  miroLogo: /*#__PURE__*/_jsx(LogoSquare, {
    width: [42, 48, 45, 45, 48],
    height: [42, 48, 45, 45, 48],
    $styles: {
      display: 'inline'
    }
  })
};
var Icon = styled(IconButton).attrs({
  $styles: {
    color: 'var(--wcds-footer-font-color)',
    marginLeft: theme.footer.icon.margin.left
  }
}).withConfig({
  displayName: "FooterIcons__Icon",
  componentId: "sc-15xs3ht-0"
})(["&:first-child{margin-left:0;}", ""], function (props) {
  return props.$display && css(["display:", ";"], props.$display);
});

var FooterIcons = function FooterIcons() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: icons.appStore,
      label: "App Store",
      href: "https://apps.apple.com/us/app/miro-collaborative-whiteboard/id1180074773?from=footer_menu&source=miro_website",
      title: "App Store"
    }), /*#__PURE__*/_jsx(Icon, {
      icon: icons.googlePlay,
      label: "Google Play",
      href: "https://play.google.com/store/apps/details?id=com.realtimeboard&from=footer_menu&source=miro_website",
      title: "Google Play"
    }), /*#__PURE__*/_jsx(Icon, {
      icon: icons.miroLogo,
      label: "Miro",
      href: "https://miro.com/",
      title: "Miro",
      $display: "var(--wcds-old-company-logo)"
    }), /*#__PURE__*/_jsx(Icon, {
      icon: /*#__PURE__*/_jsx(NewLogoSquare, {
        $styles: {
          display: 'inline'
        }
      }),
      label: "Miro",
      href: "https://miro.com/",
      title: "Miro",
      $display: "var(--wcds-new-company-logo)"
    })]
  });
};

export default FooterIcons;